<template>
  <div class="master-intervention">
    <notification-message class="notificationMessage" />

    <v-card elevation="1" class="py-7 px-9">
      <v-row>
        <h1 class="intparent-details-title text-decoration-underline">#{{ masterIntervention.id }} - {{ slug }}</h1>
      </v-row>
      <div class="mt-5">{{ masterIntervention.comment }}</div>
      <div class="mt-16">
        <div class="subtitle-1 font-weight-bold" v-if="subInterventions.length === 0">
          {{ $t('intParentDetail.emptyList') }}
        </div>

        <v-card v-for="intervention in subInterventions" :key="intervention.id" elevation="0">            
          <v-row class="d-flex flex-column flex-md-row align-center align-md-stretch justify-space-between py-lg-4">
            <v-col md="8" lg="4" class="d-flex flex-column pa-0 align-center align-md-stretch">

              <v-row class="text-subtitle text-decoration-underline font-weight-bold ma-0">
                #{{  intervention.id }} - {{ intervention.slug }}
              </v-row>

              <v-row align-md="center" class="d-flex ma-0">
                <v-col cols="auto" md="7" class="pa-0 mr-5">
                  <div class="d-flex font-weight-medium text-body-1 align-center">
                    <v-avatar v-if="getTrainerPicture(intervention.userId)" elevation="8" size="30" class="mr-2">
                      <base-64-to-image
                        :base64Image="getTrainerPicture(intervention.userId)"
                        :alt="getTrainer(intervention.userId)"
                      ></base-64-to-image>
                    </v-avatar>

                    <span>{{ getTrainer(intervention.userId) }}</span>
                  </div>
                </v-col>

                <v-col class="d-flex flex-shrink-0 align-center pa-0">
                  <div class="d-flex">
                    <v-icon :title="$t()">mdi-map-marker</v-icon>
                    {{ getLocation(intervention.locationId) }}
                  </div>
                </v-col>
              </v-row>
            </v-col>
            
            <v-col xs="auto" sm="10" md="4" lg="2" class="d-flex justify-md-space-around flex-md-column flex-lg-row flex-grow-1 my-5 my-mb-0 px-md-5 px-lg-0 py-0 px-0">
              <v-col md="7" lg="auto" class="d-flex flex-column justify-space-around justify-md-space-between align-center align-md-stretch pa-0">
                <div class="d-flex"><v-icon small class="mr-1">mdi-calendar</v-icon><span>{{ intervention.dateStart }}</span></div>
                <div class="d-flex"><v-icon small class="mr-1">mdi-calendar</v-icon><span>{{ intervention.dateEnd }}</span></div>
              </v-col>
              
              <v-col lg="auto" class="d-flex flex-column justify-space-around justify-md-space-between align-center align-md-stretch align-lg-end pa-0">
                <div class="d-flex">
                  <v-icon small class="mr-1">mdi-clock</v-icon>
                  <span class="align-self-center">{{ intervention.timeStart }}</span>
                </div>
                <div class="d-flex">
                  <v-icon small class="mr-1">mdi-clock</v-icon>
                  <span class="align-self-center">{{ intervention.timeEnd }}</span>
                </div>
              </v-col>                
            </v-col>
            
            <v-col cols="10" md="auto" lg="4" class="comment-wrapper flex-grow-1 py-0">
              {{ intervention.comment }}
            </v-col>

            <v-col cols="12" lg="1" class="d-flex flex-shrink-1 justify-space-around align-center px-0 mt-4 mt-md-0">
              <v-icon
                v-if="intervention.type === $enumInterventionStatus[1].value"
                :title="$enumInterventionStatus[1].text"
              >
                mdi-pencil
              </v-icon>

              <v-icon
                v-if="intervention.type === $enumInterventionStatus[0].value"
                :title="$enumInterventionStatus[0].text"
              >
                mdi-home
              </v-icon>

              <v-divider vertical></v-divider>

              <v-icon v-if="intervention.validated" :title="$t('intParentDetail.validatedTrue')" >mdi-check</v-icon>

              <v-icon v-else :title="$t('intParentDetail.validatedFalse')">mdi-help</v-icon>

              <v-divider vertical></v-divider>
              <div class="d-flex flex-column justify-space-between">
                <v-btn elevation="0" color="red darken-1" icon small @click="openUnlinkDialog(intervention)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-col>
            
          </v-row>
          <v-row class="my-7"><v-divider></v-divider></v-row>
        </v-card>
      </div>
    </v-card>

    <v-dialog v-model="unlinkDialog" max-width="500px">
      <v-card v-if="selectedSub">
        <v-card-title class="headline">{{ $t("intParentDetail.confirmUnlink", {id: selectedSub.id}) }}</v-card-title>
        <v-card-text>
          <v-checkbox :label="$t('intParentDetail.deleteInterevention')" v-model="deleteSub"></v-checkbox>
          <div v-if="deleteSub">
            <p class="red--text lighten-1 text">{{ $t('intParentDetail.deleteDisclaimer') }}</p>
          </div>      
        </v-card-text>
        <v-card-actions>
          <v-btn color="F44336" text @click="closeDialog()">{{ $t("crudIntParent.cancel") }}</v-btn>
          <v-btn color="F44336" text @click="unlinkSub(selectedSub, deleteSub)">{{ $t("crudIntParent.ok") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getMasterInterventionById, getSubInterventionsByMasterId } from "/src/services/planning/InterventionServices.js";
import { mapActions, mapGetters } from "vuex";
import base64ToImage from "@/components/components-base/image/base64ToImage.vue";
import notificationMessage from "@/components/components-base/notification/NotificationMessage.vue";

export default {
  components: {
    notificationMessage,
    base64ToImage
  },
  data() {
    return {
      masterIntervention: {},
      subInterventions: [],
      slug: "",
      selectedSub: null,
      unlinkDialog: false,
      deleteSub: false,
    };
  },
  mounted() {
    getMasterInterventionById(this.$route.params.id).then( res => {
      this.masterIntervention = res.data;

      getSubInterventionsByMasterId(this.masterIntervention.id).then( res => {
        this.subInterventions = res.data;
      });
      
      this.setSlug(res.data.slug);
    });

  },
  created() {
    this.loadLocations();
    this.loadCourses();
    this.loadUsers();
  },
  computed: {
    ...mapGetters('locationModule', {locations: 'getLocations'}),
    ...mapGetters('courseModule', {courses: 'getCourses'}),
    ...mapGetters('userModule', {users: 'getUsers'}),
  },
  methods: {
    ...mapActions("eventModule", ["editEvent", "deleteEvent"]),
    ...mapActions("locationModule", ["loadLocations"]),
    ...mapActions("courseModule", ["loadCourses"]),
    ...mapActions("userModule", ["loadUsers"]),
    ...mapActions('notificationModule', ['showNotification']),
    getCourseTitle(courseId) {      
      return this.courses.find( c => c.id == courseId ).title;
    },
    getTrainer(userId) {
      return this.users.find( u => u.id === userId ).fullName;
    },
    getTrainerPicture(userId) {
      const img = this.users.find( u => u.id === userId ).imagePath;
      
      if (img != undefined)
        return img;
    },
    getLocation(locId) {
      return this.locations.find( l => l.id === locId ).city;
    },
    getLocationColor(locId) {
      return this.locations.find( l => l.id === locId ).color;
    },
    openUnlinkDialog(subIntervention) {
      this.unlinkDialog = true;
      this.selectedSub = subIntervention;
    },
    closeDialog() {
      this.selectedSub = null;
      this.unlinkDialog = false;
      this.deleteSub = false;
    },
    unlinkSub(subIntervention, deleteSub) {
      if (!deleteSub) {
        subIntervention.masterInterventionId = 0;
        this.editEvent(subIntervention).then(res => {
          this.removeIntervention(subIntervention);
        });
      } else {
        this.deleteEvent(subIntervention).then(res => {
          this.removeIntervention(subIntervention);
        });

      }

      this.closeDialog();
    },
    removeIntervention(intervention) {
      this.subInterventions.splice(this.subInterventions.indexOf(intervention), 1);
    },
    setSlug(slug) {
      this.slug = slug.replace(/(?![a-z])-[0-9]+/ig, '')
                      .replaceAll(/(?![a-z])-(?=[a-z])/gi, ' ')
                      .replaceAll(/\b([a-z])/g, (c) => c.toUpperCase());
    }
  }
};
</script>

<style lang="scss">

.master-intervention {
  margin: 3rem auto;
  width: 85%;
}

.comment-wrapper {
  height: 100%;
  overflow-y: auto;
}

</style>